import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AtomizerJobsData, getInlineImage, updateCmDomains, deleteDataCM } from "../../API/api";
import { Skeleton } from "antd";
import Styles from "./Styles.module.css";
import {
  filterDomainsForComponent,
  replaceContentEditableText,
} from "../../utils";
import ReactQuill, { Quill } from "react-quill";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import VizHeader from "../VizHeader/VizHeader";
import VizButton from "../VizButtons/VizButton";
import MultiSelect from "../MultiSelect/MultiSelect";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import { Card } from "antd";
import { toast } from "react-toastify";
import { Select } from 'antd'

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const textStylesHeader = {
  fontSize: "18px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const DataRenderer = ({ data, imageData, refreshFunc, getHighlightedText, textFind }) => {
  const drawerState = useSelector((state) => state.drawer);
  const [text, setText] = useState(data.para);
  const [ques, setQues] = useState(data.head);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [relevantval, setReleventVal] = useState(data.relevant === null ? [] : data.relevant === undefined ? [] : data.relevant === 1 ? { name: "Relevant", value: 1, label: "Relevant" } : { name: "Non-Relevant", value: 0, label: "Non-Relevant" })
  const successMsg = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const onClickButton = () => {
    let payload = { ...data };
    payload.head = ques;
    payload.para = text;
    payload.relevant = relevantval.length === 0 ? null : relevantval.value;
    let newPayload = {
      soId: null,
      domainIds: null,
      data: [payload]
    }
    setIsLoading(true);
    updateCmDomains(newPayload).then(res => {
      if (res === undefined) return;
      if (res.data.success) {
        toast.success(successMsg(res.data.message));
        data.para = text;
        data.head = ques;
        data.relevant = payload.relevant;
        setIsLoading(false);
        setIsEdit(false);
      }
    })
  };
  const deleteContents = (data) => {
    // console.log("hello", data);
    let payload = {
      type: 'para',
      data: [{ docId: data.docId }]
    }
    deleteDataCM(payload).then(res => {
      if (res === undefined) return;
      refreshFunc();
    })
  }
  const addImages = (str) => {
    let imagArr = Object.keys(imageData);
    for (let i = 0; i < imagArr.length; ++i) {
      if (imagArr[i].includes(".png")) {
        let replacedContent = `[content|${imagArr[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${imageData[imagArr[i]]
          }></img>`;
        str = str.replaceAll(replacedContent, imgTag);
      } else {
        let imgTag = `<img style='max-width:50%' src=${imageData[imagArr[i]]
          }></img>`;

        let replacedContent = imagArr[i];
        str = str.replaceAll(replacedContent, imgTag);
      }
    }
    return str;
  };
  const relevantOption=[
    { label: "Relevant", value: 1 },
    { label: "Non-Relevant", value: 0 },
  ]
  const onChangeRelevant = (data) => {
    // console.log('first',data)
    let val=relevantOption.filter((item)=>item.value===data)
    setReleventVal(val[0])
  }
  return (
    <div className={Styles.cardcontainer}>
      {!isEdit && (
        <>
          <div
            style={{
              marginBottom: ".2rem",
              display: "flex",
              alignItems: "baseline",
            }}
          >
            <span className={Styles.cardHeading}>HEAD:</span>
            {textFind === '' ? <span style={{ width: "95%" }}>&nbsp;{data.head}</span> :
              getHighlightedText(data.head, textFind)}
            <span
              style={{
                display: "flex",
                justifyContent: "end",
                color: "#999",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >


              <i className="fa fa-edit"
                style={{ fontSize: '20px', color: '#ACB6C6', cursor: 'pointer' }}
                onClick={() => setIsEdit(true)}></i>
              &nbsp;&nbsp;

              <i
                className="fa fa-trash"
                style={{ fontSize: '19px', color: '#ACB6C6', cursor: 'pointer' }}
                onClick={() => deleteContents(data)}
              ></i>
            </span>

          </div>
          <div className="mt-2 mb-2" style={{ textAlign: "center" }}>
            {data.bytes !== null && (
              <img style={{ maxWidth: "50%" }} src={data.bytes} />
            )}
          </div>
          <div>
            <span className={Styles.cardHeading}>DATA:&nbsp;</span>
            {textFind === '' && <span
              dangerouslySetInnerHTML={{
                __html: replaceContentEditableText(addImages(data.para)),
              }}
              style={{ fontSize: "14px" }}
            ></span>}
            {
              textFind !== '' &&
              <span style={{ fontSize: "14px" }}
              >{getHighlightedText(data.para, textFind)}</span>
            }
          </div>
        </>
      )}
      {isEdit && (
        <>
          <div
            style={{
              marginBottom: ".2rem",
              display: "flex",
              alignItems: "baseline",
              width: "100%",
            }}
          >
            {/* <input
              type="text"
              value={ques}
              style={{
                width: "100%",
                border: "1px solid lightgrey",
                borderRadius: "3px",
                height: "40px",
              }}
              onChange={(e) => setQues(e.target.value)}
            /> */}
            <textarea wrap="soft"

              style={{
                border: '1px solid lightgrey',
                width: '100%',
                fontSize: '12px',
                borderRadius: '3px',
                outline: 'none',
                resize: 'none',
                height: '30px',
                // height:"30px",
                // alignItems:"center",
                lineHeight: '30px',   // centers text vertically
                padding: '0 8px',
                overflow: "hidden"
              }}
              // style={{ border: '1px solid rgb(224, 226, 230)', width: '200px', padding: '12px', borderRadius: '6px', outline: 'none',resize: "none",height:"30px" }} 
              type={"text"}
              value={ques}
              onChange={(e) => setQues(e.target.value)}
            // minRows={1} 
            />
          </div>
          <div>
            <ReactQuill
              theme="snow"
              value={text}
              onChange={(e) => setText(e)}
            />
          </div>
          {!isLoading && <div className="mt-1" style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'baseline' }}>
            <div>

              <div style={{ width: "200px" }}>
                {/* <Select
                  style={{ width: "100%",height:"40px" }}
                  placeholder="Select Option"
                  value={relevantval}
                  onChange={onChangeRelevant}
                  options={[
                    { label: "All", value: "All" },
                    { label: "Relevant", value: "Relevant" },
                    { label: "Non-Relevant", value: "Non-Relevant" },
                  ]}
                  maxTagPlaceholder={`${relevantval?.length || 0} selected`}
                  // allowClear={true}
                  maxTagCount="responsive" // or set to 0 to fully replace
                // maxTagPlaceholder={(omittedValues) => `${isRelevant.length} selected`}
                /> */}
                <Select
                  // mode="multiple"
                  style={{ width: "100%", height: "40px" }}
                  value={relevantval}
                  default={relevantval}
                  onChange={onChangeRelevant}
                  options={[
                    { label: "Relevant", value: 1 },
                    { label: "Non-Relevant", value: 0 },
                  ]}
                  maxTagPlaceholder={`${relevantval?.length || 0} selected`}
                  // allowClear={true}
                  maxTagCount="responsive"
                  placeholder="Select "
                />
              </div>
            </div>
            &nbsp;



            <button

              onClick={() => setIsEdit(false)}
              style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: ' 0px 1px 2px 0px #1018280D',
                color: '#2A364A',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: " #F6F7F8",
                marginBottom: '14px',
                fontWeight: 400,
                border: " 1px solid #E0E2E6",
                // cursor: "not-allowed",
                marginRight: "5px"
                //  font-weight: 400;			
              }}
            // disabled={disabled}
            // disabled
            // className="buttonDark"
            >
              Cancel

            </button>
            &nbsp;
            <button

              onClick={onClickButton}
              style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: '0px 1px 2px 0px #1018280D',
                color: '#FFFFFF',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                marginBottom: '14px',
                cursor: "pointer",
                //  font-weight: 400;			
              }}
            // disabled={disabled}
            // disabled
            // className="buttonDark"
            >
              Save

            </button>
          </div>}
        </>
      )}
    </div>
  );
};
export default function ReviewContent2() {
  const drawerState = useSelector((state) => state.drawer);
  const userData = useSelector((state) => state.user);
  const fixDomainData = () => {
    if (
      drawerState.obj.domains === undefined ||
      drawerState.obj.domains === null
    ) {
      return [];
    }
    // let newDomains = [];
    let allDomains = filterDomainsForComponent(userData.expertTopics);
    let myDomains = drawerState.obj.domains.toString();
    let newDomains = allDomains.filter((obj) => {
      if (myDomains.includes(obj.name)) {
        return obj;
      }
    });
    return newDomains;
  };
  const [origData, setOrigData] = useState([]);
  const [data, setData] = useState([]);
  const [domains, setDomains] = useState(fixDomainData());
  const [isRelevant, setRelevant] = useState({
    name: "All",
    value: "All",
    label: "All",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [inlineImageData, setInlineImageData] = useState("");
  const dispatch = useDispatch();
  const { isDrawerOpen } = bindActionCreators(Actions, dispatch);
  const [refreshData, setRefreshData] = useState('');
  const [textFind, setTextFind] = React.useState('');
  const [textReplace, setTextReplace] = React.useState('');
  const [totalMatches, setTotalMatches] = useState(0);
  const [nestedArray, setNestedArray] = React.useState([])
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\'"]/g, '\\$&');
  };
  const escapedSearchString = React.useMemo(() => {
    return textFind ? escapeRegExp(textFind) : '';
  }, [textFind]);
  const regex = React.useMemo(() => {
    return escapedSearchString ? new RegExp(escapedSearchString, 'gi') : null;
  }, [escapedSearchString]);
  const [processedData, setProcessedData] = useState([]);
  const fetchData = () => {
    setIsLoading(true);
    if (drawerState.obj.docType === "Thread") {
      drawerState.payload.data[0].page = pageNo;
    }
    AtomizerJobsData(drawerState.payload).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        if (res.data.data.inlineImages.length > 0) {
          getInlineImage(res.data.data.inlineImages).then((res2) => {
            if (res2 === undefined) return;
            if (res2.data.success) {
              setInlineImageData(res2.data.data);
            }
          });
        }
        setData(
          drawerState.obj.docType === "Thread"
            ? res.data.data.parsedData
            : res.data.data.parsedData[0]
        );
        setOrigData(
          drawerState.obj.docType === "Thread"
            ? res.data.data.parsedData
            : res.data.data.parsedData[0]
        );
        setIsLoading(false);
      }
    });
  };
  const highlightText = (text, searchTerm) => {
    if (!searchTerm) return { highlightedText: text, count: 0 };
    const escapedSearchTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
    const matches = text.match(regex);
    const highlightedText = text.replace(regex, '<span id="textRef" style="font-weight: bold; background-color: yellow;">$1</span>');
    return { highlightedText, count: matches ? matches.length : 0 };
  };

  function onHandleInlineImages(str) {
    let imagArr = Object.keys(inlineImageData);
    for (let i = 0; i < imagArr.length; ++i) {
      if (imagArr[i].includes(".png")) {
        let replacedContent = `[content|${imagArr[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${inlineImageData[imagArr[i]]
          }></img>`;
        str = str.replaceAll(replacedContent, imgTag);
      } else {
        let imgTag = `<img style='max-width:50%' src=${inlineImageData[imagArr[i]]
          }></img>`;

        let replacedContent = imagArr[i];
        str = str.replaceAll(replacedContent, imgTag);
      }
    }
    return str;
  }

  function
    getHighlightedText(text, highlight) {
    if (!highlight) {
      return text;
    }

    const escapedHighlight = escapeRegExp(highlight);
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));

    return (
      <span style={{ width: '95%' }}>
        {
          parts.map((part, i) =>
            <span
              dangerouslySetInnerHTML={{ __html: replaceContentEditableText(onHandleInlineImages(part)) }}
              key={i}
              style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold', backgroundColor: 'yellow' } : {}}
            >
            </span>
          )
        }
      </span>
    );
  }
  const onChangeDomain = (domain) => {
    setDomains(domain);
    let payload = {
      soId: drawerState.obj.soId,
      domainIds: domain.map(dn => dn.indexId).toString(),
      data: []
    }
    updateCmDomains(payload).then(res => {
    })
  };
  const onChangeRelevant = (option) => {
    setRelevant(option);
    if (option === 'All') {
      setData(origData);
    }
    if (option === 'Relevant') {
      let newData = origData.filter(obj => {
        if (obj.relevant === 1) {
          return obj;
        }
      })
      setData(newData);
    }
    if (option === 'Non-Relevant') {
      let newData = origData.filter(obj => {
        if (obj.relevant === 0) {
          return obj;
        }
      })
      setData(newData);
    }

  };
  const refresh = () => {
    setRelevant({
      name: "All",
      value: "All",
      label: "All",
    })
    setRefreshData(Math.random() * 10)
  }

  const onChangeTextFind = (e) => {
    const trimmedValue = e.target.value.replace(/^\s+/, '');
    setTextFind(trimmedValue)
    //   // setTextFind(e.target.value.replace(/\s/g, ''));
    //   let totalCount = 0;
    //   const processed = nestedArray.map((item) => {
    //     let newItem = { ...item };
    //     const headResult = highlightText(item.head);
    //     const updatedHead = headResult.highlightedText.replace(/(<span id="textRef">)(.*?)(<\/span>)/gi, (match, p1, p2, p3) => {
    //       const { highlightedText, count } = highlightText(p2);
    //       totalCount += count;
    //       return `${p1}${highlightedText}${p3}`;
    //     });
    //     // totalCount += headResult.count;
    //     const paraResult = highlightText(item.para);
    //     getHighlightedText(item.head,textFind)
    //     totalCount += paraResult.count;
    //     const updatedPara = paraResult.highlightedText.replace(/(<span id="textRef">)(.*?)(<\/span>)/gi, (match, p1, p2, p3) => {
    //       const { highlightedText, count } = highlightText(p2);
    //       totalCount += count;
    //       return `${p1}${highlightedText}${p3}`;
    //     });
    //     // newItem.head = headResult.highlightedText;
    //     newItem.head = updatedHead
    //     newItem.para = updatedPara;
    //     return newItem;
    //   });
    //   setProcessedData(processed);
    //   // setData(processed)
    //   setTotalMatches(totalCount);

    let totalCount = 0;
    const processed = data.map((item) => {
      let newItem = { ...item };
      const headResult = highlightText(item.head, trimmedValue);
      totalCount += headResult.count;
      const paraResult = highlightText(item.para, trimmedValue);
      totalCount += paraResult.count;
      newItem.head = headResult.highlightedText;
      newItem.para = paraResult.highlightedText;
      return newItem;
    });
    setProcessedData(processed);
    setTotalMatches(totalCount);
  }

  const onChangeTextPlace = (e) => {
    setTextReplace('')
    const trimmedValue = e.target.value.replace(/^\s+/, '');
    setTextReplace(trimmedValue)
  }

  const onButtonReplace = () => {
    // setData(processedData)
    const successMsg = (message) => {
      return (
        <>
          <span style={{ fontSize: "12px" }}>{message}</span>
        </>
      );
    };
    let payloadArr = data.filter((item, index) => {
      if (regex.test(item.head) || regex.test(item.para)) {
        let newItem = item.head.replace(regex, (match) => `${textReplace}` + ` `)
        item.head = newItem
        let newItem2 = item.para.replace(regex, (match) => `${textReplace}` + ` `)
        item.para = newItem2;
        // payloadArr.push(item)
        return item;
      }
    })
    let newPayload = {
      soId: null,
      domainIds: null,
      data: payloadArr
    }
    if (payloadArr.length > 0) {
      setIsLoading(true);
      updateCmDomains(newPayload).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          toast.success(successMsg(res.data.message));
          // data.para = text;
          // data.head = ques;
          // data.relevant = payload.relevant;
          setIsLoading(false);
          // setIsEdit(false);
          setTextFind('')
          setTextReplace('')
          // setData(payloadArr)
        }
      })
    }
  }
  useEffect(() => {
    fixDomainData();
    fetchData();
  }, [refreshData]);
  return (
    <>
      {isLoading && (
        <div>
          <Skeleton active />
          <br />
          <Skeleton active />
          <br />
          <Skeleton active />
          <br />
          <Skeleton active />
        </div>
      )}
      {!isLoading && (
        <div style={{ overflowY: 'auto' }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={Styles.header} style={{ width: "55%" }}>
              <span style={textStylesHeader}>Review Content</span>
              {/* <VizHeader type={"2"}>Review Content2</VizHeader> */}
            </div>
            <div style={{
              width: "45%",
              textAlign: "end",
            }}>
              <i
                className="fa fa-times-circle"
                onClick={() => isDrawerOpen(false)}
                style={{
                  // width: "45%",
                  fontSize: "24px",
                  color: "#dc2f02",
                  cursor: "pointer",
                  // textAlign: "end",
                }}
              ></i>
            </div>
          </div>
          <hr style={{ marginBottom: "0px" }} />
          <div
            className="mt-4 mb-2"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ width: "200px" }}>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Option"
                value={isRelevant}
                onChange={onChangeRelevant}
                defaultValue={{ label: "All", value: "All", name: "All" }}
                options={[
                  { label: "All", value: "All" },
                  { label: "Relevant", value: "Relevant" },
                  { label: "Non-Relevant", value: "Non-Relevant" },
                ]}
                allowClear={false}
              />
            </div>
            {/* <div>
                <MultiSelectCmTwo
                  value={isRelevant}
                  onChangeFunc={onChangeRelevant}
                  isMulti={false}
                  options={[
                    { name: "All", value: "All", label: "All" },
                    { name: "Relevant", value: "Relevant", label: "Relevant" },
                    {
                      name: "Non-Relevant",
                      value: "Non-Relevant",
                      label: "Non-Relevant",
                    },
                  ]}
                />
            </div> */}
          </div>
          {
            data.length > 0 &&
            <textarea
              wrap="soft"
              style={{
                border: '1px solid rgb(224, 226, 230)',
                width: '200px',            // same width as input
                height: '30px',            // same height as input
                // fontSize: '12px',
                borderRadius: '3px',
                outline: 'none',
                resize: 'none',
                padding: '0 8px',          // horizontal padding only
                lineHeight: '30px',        // ✅ centers text vertically
                boxSizing: 'border-box',
                overflow: 'hidden'   // ensures exact dimensions
              }}
              rows={1}
              placeholder="Replace From"
              autoComplete="off"
              value={textFind}
              name="name"
              onChange={(e) => onChangeTextFind(e)}
            />
            // <input autoComplete="off" className="mb-2" type="text" placeholder="Replace From" value={textFind} name="name" onChange={(e) => onChangeTextFind(e)}
            //   //  style={{ width: '200px', fontSize: '12px', borderRadius: '3px', border: '1px solid lightgrey', padding: '4px 8px' }} 
            //   style={{
            //     border: '1px solid lightgrey',
            //     width: '200px',
            //     fontSize: '12px',
            //     borderRadius: '3px',
            //     outline: 'none',
            //     resize: 'none',
            //     height: '30px',
            //     // height:"30px",
            //     // alignItems:"center",
            //     // lineHeight: '30px',   // centers text vertically
            //     padding: '0 8px',
            //   }}

            // />
          }
          {(textFind !== '') && <><span style={{ fontSize: '12px' }}>{" "}Total Matches:{" "}{totalMatches}</span></>}
          {data.length > 0 &&
            <>
              <div style={{ marginTop: "8px" }}>
                {/* <></> */}
                {/* <input autoComplete="off" className="mb-1" placeholder="Replace To"
                  //  style={{ width: '200px', fontSize: '12px', borderRadius: '3px', border: '1px solid lightgrey', padding: '4px 8px' }} 
                  style={{
                    border: '1px solid lightgrey',
                    width: '200px',
                    fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    height: '30px',
                    // height:"30px",
                    // alignItems:"center",
                    // lineHeight: '30px',   // centers text vertically
                    padding: '0 8px',
                  }}

                  value={textReplace} onChange={(e) => onChangeTextPlace(e)} /> */}
                <textarea
                  wrap="soft"
                  style={{
                    border: '1px solid rgb(224, 226, 230)',
                    width: '200px',            // same width as input
                    height: '30px',            // same height as input
                    // fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    padding: '0 8px',          // horizontal padding only
                    lineHeight: '30px',        // ✅ centers text vertically
                    boxSizing: 'border-box',
                    overflow: 'hidden'   // ensures exact dimensions
                  }}
                  rows={1}
                  placeholder="Replace To"
                  autoComplete="off"
                  value={textReplace}
                  name="name"
                  onChange={(e) => onChangeTextPlace(e)}
                />
              </div>
              {(textFind !== '' && textReplace !== '' && totalMatches > 0) &&
                <div className="mt-1 mb-2" >
                  <button

                    onClick={() => onButtonReplace()}
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      cursor: "pointer",
                      //  font-weight: 400;			
                    }}
                  // disabled={disabled}
                  // disabled
                  // className="buttonDark"
                  >
                    Replace

                  </button>
                  {/* <VizButton size={4}
                    type={"Primary"} onClick={onButtonReplace}>Replace</VizButton> */}
                </div>}
              {
                ((textFind === '' || textReplace === '' || textFind && textReplace === '' || totalMatches === 0)) &&
                <div className="mt-1 mb-2">

                  <button

                    onClick={() => onButtonReplace()}
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: ' 0px 1px 2px 0px #1018280D',
                      color: '#2A364A',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      fontWeight: 400,
                      border: " 1px solid #E0E2E6",
                      cursor: "not-allowed",
                      color: "white"
                      //  font-weight: 400;			
                    }}
                    // disabled={disabled}
                    disabled
                  // className="buttonDark"
                  >
                    Replace

                  </button>
                </div>
              }
            </>}
          {data?.length > 0 && <Card style={{ boxShadow: "7px 7px 20px lightgrey" }}>
            {data.map((obj) => {
              return (
                <>
                  {drawerState.obj.docType !== "Thread" && (
                    <DataRenderer imageData={inlineImageData} data={obj} refreshFunc={refresh} getHighlightedText={getHighlightedText} textFind={textFind} />
                  )}
                  {drawerState.obj.docType === "Thread" &&
                    obj.map((obj2) => {
                      return (
                        <DataRenderer imageData={inlineImageData} data={obj2} getHighlightedText={getHighlightedText} textFind={textFind} />
                      );
                    })}
                </>
              );
            })}
          </Card>
          }

        </div>
      )}
    </>
  );
}
